<template>
  <div class="main_filter ml-4">
    <p class="mt-3" style="font-size: 22px; font-weight: bolder">ตัวกรอง</p>
    <div class="row">
      <div class="col-12 row">
        <div class="col-3">
          <multiselect
            v-if="options1"
            v-model="value1"
            :close-on-select="true"
            :options="options1"
            label="text"
            track-by="value"
            :searchable="true"
            :show-labels="false"
            class="multiselect-style2 custom-multiselect"
            placeholder="ทุกภูมิภาค"
          ></multiselect>
        </div>
        <div class="col-3">
          <multiselect
            v-if="options2"
            v-model="value2"
            :close-on-select="true"
            :options="options2"
            label="name"
            track-by="community_id"
            :searchable="true"
            :show-labels="false"
            class="multiselect-style2 custom-multiselect"
            placeholder="ทุกชุมชน"
          ></multiselect>
        </div>
        <div class="col-3">
          <multiselect
            v-if="options3"
            v-model="value3"
            :close-on-select="true"
            :options="options3"
            label="text"
            track-by="value"
            :searchable="true"
            :show-labels="false"
            class="multiselect-style2 custom-multiselect"
            placeholder="ทุกประเภทแปลง"
          ></multiselect>
        </div>
        <div class="col-3">
          <multiselect
            v-if="options4"
            v-model="value4"
            :close-on-select="true"
            :options="options4"
            label="name"
            track-by="category_id"
            :searchable="true"
            :show-labels="false"
            class="multiselect-style2 custom-multiselect"
            placeholder="ทุกกลุ่มชนิดพืช"
          ></multiselect>
        </div>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-12 row">
        <div class="col-3">
          <multiselect
            v-if="options5"
            v-model="value5"
            :close-on-select="true"
            :options="options5"
            label="name"
            track-by="knowledge_level1_id"
            :searchable="true"
            :show-labels="false"
            class="multiselect-style2 custom-multiselect"
            placeholder="ทุกภูมิปัญญา"
          ></multiselect>
        </div>
        <div class="col-3">
          <multiselect
            v-if="options6"
            v-model="value6"
            :close-on-select="true"
            :options="options6"
            label="name"
            track-by="habitat_id"
            :searchable="true"
            :show-labels="false"
            class="multiselect-style2 custom-multiselect"
            placeholder="ทุกแหล่งที่พบ"
          ></multiselect>
        </div>
        <div class="col-3">
          <multiselect
            v-if="options7"
            v-model="value7"
            :close-on-select="true"
            :options="options7"
            label="name"
            track-by="habit_id"
            :searchable="true"
            :show-labels="false"
            class="multiselect-style2 custom-multiselect"
            placeholder="ทุกลักษณะวิสัย"
          ></multiselect>
        </div>
        <div class="col-3">
          <multiselect
            v-if="options8"
            v-model="value8"
            :close-on-select="true"
            :options="options8"
            label="name"
            track-by="benefit_id"
            :searchable="true"
            :show-labels="false"
            class="multiselect-style2 custom-multiselect"
            placeholder="ทุกประโยชน์"
          ></multiselect>
        </div>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-12 row">
        <div class="col-3">
          <multiselect
            v-if="options9"
            v-model="value9"
            :close-on-select="true"
            :options="options9"
            label="text"
            track-by="value"
            :searchable="true"
            :show-labels="false"
            class="multiselect-style2 custom-multiselect"
            placeholder="ทุกสถานะ"
          ></multiselect>
        </div>
        <div class="col-3">
          <multiselect
          v-if="options10"
            v-model="value10"
            :close-on-select="true"
            :options="options10"
            label="text"
            track-by="value"
            :searchable="true"
            :show-labels="false"
            class="multiselect-style2 custom-multiselect"
            placeholder="ทุกสถานะการเผยแพร่"
          ></multiselect>
        </div>
        <div class="col-3">
          <b-button
            class="btn btn-block"
            pill
            style="background-color: #41634a; height: 34px"
            @click="onSearch"
          >
            ค้นหา
          </b-button>
        </div>
        <div class="col-3">
          <b-button
            class="btn btn-block"
            pill
            style="background-color: #db7f50; height: 34px"
            @click="onExport"
          >
            EXPORT
          </b-button>
        </div>
      </div>
      <div class="col-2"></div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from "vuex";
import Multiselect from "vue-multiselect";

export default {
  name: "main_filter_admin",
  data() {
    return {
      value1: "",
      value2: "",
      value3: "",
      value4: "",
      value5: "",
      value6: "",
      value7: "",
      value8: "",
      value9: "",
      value10: "",
      //ภาคกลาง 2
      //ภาคเหนือ 1
      //ภาคตะวันออกเฉียงเหนือ 3
      //ภาคตะวันออก 5
      //ภาคตะวันตก 4
      //ภาคใต้ 6
      options1: [
        { text: "ภาคกลาง", value: 2 },
        { text: "ภาคเหนือ", value: 1 },
        { text: "ภาคตะวันออกเฉียงเหนือ", value: 3 },
        { text: "ภาคตะวันออก", value: 5 },
        { text: "ภาคตะวันตก", value: 4 },
        { text: "ภาคใต้", value: 6 },
      ],
      options2: [],
      options3: [
        { text: "แปลงสำรวจ", value: 1 },
        { text: "แปลงธนาคาร", value: 2 },
      ],
      options4: [],
      options5: [],
      options6: [],
      options7: [],
      options8: [],
      options9: [
        { text: "ฉบับร่าง", value: 1 },
        { text: "ตรวจสอบ", value: 2 },
        { text: "อนุมัติ", value: 3 },
        { text: "ไม่อนุมัติ", value: 4 },
      ],
      options10: [
        { text: "เผยแพร่", value: 1 },
        { text: "ไม่เผยแพร่", value: 0 },
      ],
    };
  },
  async created() {
    await this.$store.dispatch("OptionsModule/onGetOption");
    this.options2 = this.option2;
    this.options4 = this.option4;
    this.options5 = this.option5;
    this.options6 = this.option6;
    this.options7 = this.option7;
    this.options8 = this.option8;
  },
  computed: {
    ...mapState({
      option2: (state) => {
        return state.OptionsModule.community;
      },
      option4: (state) => {
        return state.OptionsModule.categories;
      },
      option5: (state) => {
        return state.OptionsModule.knowledge_level1s;
      },
      option6: (state) => {
        return state.OptionsModule.habitats;
      },
      option7: (state) => {
        return state.OptionsModule.habits;
      },
      option8: (state) => {
        return state.OptionsModule.benefits;
      },
    }),
  },
  components: {
    Multiselect,
  },
  methods: {
    onSearch() {
      let data = {
        geography: this.value1 ? this.value1.value : "",
        community: this.value2 ? this.value2.community_id : "",
        plotType: this.value3 ? this.value3.value : "",
        category: this.value4 ? this.value4.category_id : "",
        knowledge: this.value5 ? this.value5.knowledge_level1_id : "",
        habit: this.value6 ? this.value6.habitat_id : "",
        habitat: this.value7 ? this.value7.habit_id : "",
        benefit: this.value8 ? this.value8.benefit_id : "",
        status: this.value9 ? this.value9.value : "",
        publish: this.value10 ? this.value10.value : "",
      };
      this.$store.dispatch("dashboardModule/searchBE", data);
    },
    onExport() {
      let data = {
        geography: this.value1 ? this.value1.value : "",
        community: this.value2 ? this.value2.community_id : "",
        plotType: this.value3 ? this.value3.value : "",
        category: this.value4 ? this.value4.category_id : "",
        knowledge: this.value5 ? this.value5.knowledge_level1_id : "",
        habit: this.value6 ? this.value6.habitat_id : "",
        habitat: this.value7 ? this.value7.habit_id : "",
        benefit: this.value8 ? this.value8.benefit_id : "",
        status: this.value9 ? this.value9.value : "",
        publish: this.value10 ? this.value10.value : "",
      };
      this.$store.dispatch("dashboardModule/ExportExcel", data);
    },
  },
};
</script>
<style lang="scss">
.main_filter {
  min-height: 10vh;
}

.btn {
  width: 80% !important;
  margin: auto;
}
</style>
